import { Link } from "@inertiajs/react";

export default function SimilarCollection({ collection }) {
    const link = `/collections/${collection.alias}`;
    return (
        <Link href={link} className="w-full flex flex-col hover:border hover:border-blue-500 rounded border">
            <div className="flex items-center justify-center p-5">
                <div className="h-[50px] flex justify-center items-center" >
                    <img className="w-100 max-h-[50px]" src={collection.image?.url} />
                </div>
            </div>
            <div className="p-5 pt-0">
                <div className="text-center overflow-hidden text-ellipsis">
                    <span className="">
                        {collection.name}
                    </span>
                </div>
            </div>
        </Link >
    )
}